import { createRoot } from "react-dom/client";
import NorthStarPresentation from "./northstar-presentation.jsx";

const container = document.getElementById("presentation-root");
if (container) {
  createRoot(container).render(<NorthStarPresentation />);
}
